/*
 * Return a copy of `obj` without the key `key`
 */
export function omit(obj, ...keys: Array<PropertyKey>) {
    const keySet = new Set(keys);
    const result = {};
    for (const k of Object.keys(obj)) {
        if (!keySet.has(k)) {
            result[k] = obj[k];
        }
    }
    return result;
}
